import React, { useEffect, useRef, useState } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import _ from 'lodash';
import { BasicText, FlexBlockWrapped, Loading, PageWrapper, ShinyBlockOuter } from '../../Styles';
import Programs from './Programs';
import SiteInfo from './SiteInfo';
import Services from './Services';
import Alerts from './Alerts';
import Schedule from './Schedule';
import Map from './SiteMap';
import Util from '../../core/Util';

const SiteView = ({siteId, portalData}) => {
    const [site, setSite] = useState(null);
    const [client, setClient] = useState(null);
    const [services, setServices] = useState([]);
    const [alerts, setAlerts] = useState([]);
    const [schedulePosition, setSchedulePosition] = useState(null);

    useEffect(()=>{
        if(site == null || site.site_id != siteId){
            if(portalData.sites != undefined){
                setSite( _.find(portalData.sites, {site_id: parseInt(siteId)}) );
            }
        }
    }, [portalData, siteId]);

    useEffect(()=>{
        if(site != undefined){
            setClient( _.find(portalData.clients, {client_id: site.client_id}) );

            if(portalData.services != undefined){
                const filteredServices = _.filter(portalData.services, {site: site.site_id});
                setServices(filteredServices);
            }

            if(portalData.alerts != undefined){
                const filteredAlerts = _.filter(portalData.alerts, {site_id: site.site_id});
                setAlerts(filteredAlerts);
            }
        }
    }, [site]);

    if(site == null || client == null){
        return <Loading />;
    }

    const mapHeight = 400;
    const badgeHeight = 75;

    const jumpToSchedule = () => {
        window.scrollTo(0,schedulePosition.top);
    }
    
    return <PageWrapper>
        <View style={{flexBasis: Util.isMobile()? "95%" : "49%", alignItems: "center", marginHorizontal: 5}}>
            <SiteInfo site={site} client={client} services={services} jumpToSchedule={jumpToSchedule} supportAccess={portalData != undefined && portalData.user != undefined && portalData.user.portalProfileSettings != undefined && portalData.user.portalProfileSettings.supportAccess == true}/>
            {alerts.length > 0? <Alerts site={site} alerts={alerts}/> : null}
        </View>
        <Map site={site} height={mapHeight}/>
        <Programs site={site} badgeHeight={badgeHeight} services={<Services services={services} defaultMaxHeight={badgeHeight} userInfo={portalData.user}/>}/>
        <Schedule site={site} services={services} setPosition={(layout)=>setSchedulePosition(layout)}/>
    </PageWrapper>;
}

export default SiteView;